module.exports = __webpack_public_path__ + "img/2.075566dd.jpg";